module.exports = __webpack_public_path__ + "img/schlussrunde.45c3a52e.png";